import create from 'zustand';

type ScrollStore = {
  position: number,
  setPosition: (p: number) => void,

  scrollTo: ((p: number, immediate: boolean) => void) | null,
  setScrollTo: ((fn: (p: number, immediate: boolean) => void) => void) | null,

  isLocked: boolean,
  lockScroll: () => void,
  unlockScroll: () => void
}

const useScrollStore = create<ScrollStore>(set => ({
  position: 0,
  setPosition: p => set(() => ({ position: p })),

  scrollTo: null,
  setScrollTo: fn => set(() => ({ scrollTo: fn })),

  isLocked: false,
  lockScroll: () => set(() => ({ isLocked: true })),
  unlockScroll: () => set(() => ({ isLocked: false }))
}));

export default useScrollStore;